export const databaseList: KeyValue[] = [
  { key: 'Opus', value: 'opus' },
  { key: 'Contract', value: 'contract' },
  { key: 'Credit Report', value: 'credit-report' }
];

export class KeyValue {
  key: string;
  value: string;
}
